module.exports = __webpack_public_path__ + "img/image3.65a24102.png";